import * as quotas from "./../quotas"
import { QuotaUsageType, StaticQuotaName } from "@budibase/types"
import { db } from "@budibase/backend-core"

interface AppOpts {
  appId?: string
}

// DEV

const getDevAppsCount = async () => {
  const apps = await db.getAllApps({ dev: true })
  return apps ? apps.length : 0
}

export const addApp = async (addAppFn: any, { appId }: AppOpts = {}) => {
  return quotas.increment(StaticQuotaName.APPS, QuotaUsageType.STATIC, {
    fn: addAppFn,
    valueFn: getDevAppsCount,
    id: appId,
  })
}

export const removeApp = async ({ appId }: AppOpts = {}) => {
  return quotas.decrement(StaticQuotaName.APPS, QuotaUsageType.STATIC, {
    valueFn: getDevAppsCount,
    id: appId,
  })
}
